'use client'

import { useState, useEffect } from 'react'
import { debounce } from 'lodash-es'

type WindowSize = { width?: number; height?: number }

function useWindowSize(): WindowSize {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    })

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        const debouncedResize = debounce(handleResize, 200)

        window.addEventListener('resize', debouncedResize)

        // Call handler right away so state gets updated with initial window size
        handleResize()

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', debouncedResize)
    }, []) // Empty array ensures that effect is only run on mount

    return windowSize
}

export default useWindowSize
